import React from "react";
import DataList from "components/datatable/DataList";
import { showEmpty } from "./SystemPageUtils";

function formatLocaleDateTime(value) {
  if (!value) return showEmpty(value);
  const normalizedValue = String(value).replace(/([+-]\d{2})$/, "$1:00");
  const date = new Date(normalizedValue);
  if (Number.isNaN(date.getTime())) return showEmpty(value);
  const datePart = [
    `${date.getDate()}`.padStart(2, "0"),
    `${date.getMonth() + 1}`.padStart(2, "0"),
    date.getFullYear(),
  ].join("/");
  const timePart = [
    `${date.getHours()}`.padStart(2, "0"),
    `${date.getMinutes()}`.padStart(2, "0"),
    `${date.getSeconds()}`.padStart(2, "0"),
  ].join(":");
  return `${datePart} ${timePart}`;
}

function formatJSONText(value) {
  if (!value) return showEmpty(value);
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch (err) {
    return value;
  }
}

function renderJSONText(value) {
  const text = formatJSONText(value);
  if (text === "-") return text;
  return (
    <pre
      style={{
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        margin: 0,
        fontSize: 12,
        color: "#6c757d",
      }}
    >
      {text}
    </pre>
  );
}

export default function SystemTablePage({ title, url }) {
  const coltype = {
    id_audit_log: { label: "ID", width: 80, align: "center" },
    username: {
      label: "Username",
      renderFunc: (val) => showEmpty(val),
      width: 140,
    },
    groupname: {
      label: "Group",
      renderFunc: (val) => showEmpty(val),
      width: 160,
    },
    context_type: {
      label: "Context Type",
      renderFunc: (val) => showEmpty(val),
      width: 130,
    },
    context_id: {
      label: "Context ID",
      renderFunc: (val) => showEmpty(val),
      width: 220,
    },
    audit_action: {
      label: "Action",
      renderFunc: (val) => showEmpty(val),
      width: 180,
    },
    audit_action_label: {
      label: "Aktifitas",
      renderFunc: (val) => showEmpty(val),
      width: 150,
    },
    entity_type: {
      label: "Entity Type",
      renderFunc: (val) => showEmpty(val),
      width: 150,
    },
    entity_label: {
      label: "Objek",
      renderFunc: (val) => showEmpty(val),
      width: 160,
    },
    entity_id: {
      label: "Entity ID",
      renderFunc: (val) => showEmpty(val),
      width: 220,
    },
    ringkasan: {
      label: "Ringkasan",
      renderFunc: (val) => showEmpty(val),
      width: 320,
    },
    created_at: {
      label: "Waktu",
      renderFunc: (val) => formatLocaleDateTime(val),
      renderExportFunc: (val) => formatLocaleDateTime(val),
      width: 150,
    },
    old_data: {
      label: "Old Data",
      renderFunc: (val) => renderJSONText(val),
      renderExportFunc: (val) => formatJSONText(val),
      viewsize: 12,
    },
    new_data: {
      label: "New Data",
      renderFunc: (val) => renderJSONText(val),
      renderExportFunc: (val) => formatJSONText(val),
      viewsize: 12,
    },
    ip_address: {
      label: "IP Address",
      renderFunc: (val) => showEmpty(val),
      viewsize: 4,
    },
    user_agent: {
      label: "User Agent",
      renderFunc: (val) => showEmpty(val),
      viewsize: 8,
    },
    action: {
      label: "Aksi",
      width: 80,
      align: "center",
    },
  };

  return (
    <>
      <DataList
        title={title}
        coltype={coltype}
        dlist={{
          url,
          columns: [
            "no",
            "username",
            "audit_action_label",
            "entity_label",
            "ringkasan",
            "created_at",
            "action",
          ],
          filter: [
            { dtype: "q", name: "q", colsize: 4 },
            {
              dtype: "date",
              name: "tanggal_mulai",
              label: "Tanggal Mulai",
              colsize: 2,
            },
            {
              dtype: "date",
              name: "tanggal_sampai",
              label: "Sampai Tanggal",
              colsize: 2,
            },
          ],
          sort_by: [
            "username",
            "audit_action_label",
            "entity_label",
            "ringkasan",
            "created_at",
          ],
        }}
        detailconfig={{
          url,
          cellid: "id_audit_log",
          title: "Detail Audit Log",
          tooltip: "Detail",
          icon: "fa-search",
          size: "xl",
          columns: [
            "id_audit_log",
            "username",
            "groupname",
            "audit_action_label",
            "entity_label",
            "ringkasan",
            "audit_action",
            "entity_type",
            "entity_id",
            "context_type",
            "context_id",
            "created_at",
            "ip_address",
            "user_agent",
            "old_data",
            "new_data",
          ],
        }}
      />
    </>
  );
}
